import { Dispatch } from "redux";
import { AxnAdminSecurityRule } from "@idw-types/data/management-console/axnadmin";
import { updateAxnAdminSecurityRuleRequest } from "@requests/management-console/update-axn-admin-security-rule";
import { displaySuccessModal, logAndDisplayErrorModal } from "@utils/app-alert-util";
import { resources } from "@constants/hardcoded-strings";
import { replaceSecurityRule } from "@redux/actions/security-rules-actions";

export const updateSecurityRuleReduxRequest = (dispatch: Dispatch) => async (
    original: AxnAdminSecurityRule,
    modified: AxnAdminSecurityRule
) => {
    const { data, error, body } = await updateAxnAdminSecurityRuleRequest(original, modified);
    if (data?.transferObject) {
        dispatch(replaceSecurityRule(data.transferObject));
        displaySuccessModal(
            dispatch,
            resources.requests.updateSecurityRule.success.title,
            resources.requests.updateSecurityRule.success.message
        );
        return data.transferObject;
    } else if (error) {
        logAndDisplayErrorModal(
            dispatch,
            error,
            resources.requests.updateSecurityRule.error.title,
            resources.requests.updateSecurityRule.error.message,
            null,
            null,
            body
        );
    }

    return null;
};